
import "../styles/AddTribute.css"
import { FaEdit } from "react-icons/fa"
import { BsFillTrash2Fill } from "react-icons/bs"
import { useEffect, useState } from "react"


const AddTribute = () => {
  const [media, setMedia] = useState([]); // Holds file objects
  const [mediaPreviews, setMediaPreviews] = useState([]); // Holds preview URLs
  const [loading, setLoading] = useState(false);

  // Update previews when media changes
  useEffect(() => {
    const previews = media.map((file) =>
      file.type.startsWith("image/")
        ? URL.createObjectURL(file) // Generate URL for images
        : file.type.startsWith("video/")
        ? URL.createObjectURL(file) // Generate URL for videos
        : null
    );
    setMediaPreviews(previews);

    // Cleanup previews on component unmount
    return () => previews.forEach((preview) => URL.revokeObjectURL(preview));
  }, [media]);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files); // Convert FileList to Array
    setMedia((prevMedia) => [...prevMedia, ...files]);
  };

  const handleDeleteMedia = (index) => {
    setMedia((prevMedia) => prevMedia.filter((_, i) => i !== index));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      media.forEach((file) => formData.append("files[]", file));

      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 2000));
      console.log("Files submitted!");
    } catch (error) {
      console.error("Error submitting files:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="addTribute">
      <div className="addTributeHeading">
        <h2>Write a tribute for the deceased</h2>
        <p>
          Write a heartfelt message to honor the memory of our loved one,
          reflecting on their life and impact.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="inputContainer">
          <div className="inputWrapper">
            <label>Full Name</label>
            <small>Enter your first name as it may appear on the tribute</small>
            <input type="text" placeholder="Enter your full name" required />
          </div>
          <div className="inputWrapper">
            <label>Relationship</label>
            <small>What is your relationship with the deceased?</small>
            <input type="text" placeholder="Enter your relationship" required />
          </div>
        </div>
        <div className="inputWrapper">
          <label>Profile Picture</label>
          <small>Upload a profile photo as it will appear on the tribute.</small>
          <input type="file" accept="image/*" />
        </div>
        <div className="inputWrapper">
          <label>Tribute</label>
          <small>Write your tribute here</small>
          <textarea
            rows={7}
            placeholder="Write your tribute here"
            required
          ></textarea>
        </div>
        <div className="inputWrapper">
          <label>Tribute Images/Videos</label>
          <small>Upload images or videos to attach to your tribute</small>
          <input
            type="file"
            accept="image/*,video/*"
            multiple
            onChange={handleFileChange}
          />
        </div>
        <div className="mediaPreview">
          {mediaPreviews.map((preview, index) => (
            <div key={index} className="mediaHolder">
              {media[index].type.startsWith("image/") ? (
                <img src={preview} alt="Preview" />
              ) : (
                <video src={preview} controls />
              )}
              <BsFillTrash2Fill
                className="deleteIcon"
                onClick={() => handleDeleteMedia(index)}
              />
            </div>
          ))}
        </div>
        <div className="addTributeButton">
          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit Tribute"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddTribute;

